import { Injectable } from '@angular/core';

@Injectable()
export class AccountStatsService {

  public Initialized: boolean = false;

  public TotalAccounts: number = 0;
  public TodoAccounts: number = 0;
  public WorkedAccounts: number = 0;
  public DoneAccounts: number = 0;

  public midstageTotal: number = 0;
  public midstageTodo: number = 0;
  public midstageWorked: number = 0;
  public midstageDone: number = 0;

  public TotalDNCNumbers: number = 0;
  public TodoDNCNumbers: number = 0;
  public DoneDNCNumbers: number = 0;

  public WorkedToday: number = 0;
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/account-stats.service.ts